import axios from 'axios';

const SITES_API = `${process.env.VUE_APP_API_URL}/v3/templates`;

export const getCurrentTemplate = async () => (await axios.get(`${SITES_API}/current`)).data;
export const getTemplateById = (templateId) => axios.get(`${SITES_API}/${templateId}`);
